import { Component, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material';
import { GlobalService } from '../../providers/global.service';
import { AuthService } from '../../providers/auth.service';
import { ProfilePopoverPage } from 'src/app/pages/modal/profilepopover/profilepopover.page';
import { PopoverController } from '@ionic/angular';

@Component({
    selector: 'horizontal-navbar',
    templateUrl: 'horizontal-navbar.component.html',
    styleUrls: ['horizontal-navbar.component.scss'],
})

export class HorizontalNavbarComponent {
    gs = GlobalService;
    NewRequestList = ['form1', 'form2', 'form3']
    designation: string;
    rolename: string;
    todaysdate: string;
    currentDate: Date;
    DesignationsList: any = [
        { id: 0, name: 'Admin', value: 0, selected: true },
        { id: 1, name: 'Sachiv', value: 1, selected: false },
        { id: 2, name: 'Sarpanch', value: 2, selected: false },
        { id: 3, name: 'BDPO', value: 3, selected: false },
        { id: 4, name: 'Chairman', value: 4, selected: false },
        { id: 5, name: 'CEO', value: 5, selected: false },
        { id: 6, name: 'President', value: 6, selected: false },
        { id: 7, name: 'DDPO', value: 7, selected: false },
        { id: 8, name: 'XEN', value: 8, selected: false },
        { id: 9, name: 'State Admin', value: 9, selected: false },
        { id: 10, name: 'Super Admin', value: 10, selected: false },
    ]

    RolesList: any = [
        { id: 0, name: 'Select', value: 'Select', selected: true },
        { id: 1, name: 'Admin', value: 1, selected: false },
        { id: 2, name: 'Maker', value: 2, selected: false },
        { id: 3, name: 'Checker', value: 3, selected: false },
        { id: 4, name: 'Viewer', value: 4, selected: false },
        { id: 5, name: 'Super Admin', value: 5, selected: false },
    ]

    constructor(private authService: AuthService, public popoverController: PopoverController) {
        this.currentDate = new Date();
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        let yyyy = today.getFullYear();
        this.todaysdate = dd + '/' + mm + '/' + yyyy;
       

    }
    

    ionViewDidEnter() {
    }
    ionViewDidLeave() {
        this.rolename = "";
        this.designation = "";

    }

    logout() {
        this.authService.logout();
    }
    async presentPopover(ev: any) {
        const popover = await this.popoverController.create({
            component: ProfilePopoverPage,
            event: ev,
            translucent: true
        });
        return await popover.present();
    }
}
